<!-- How to Buy Modal Backdrop -->
<div class="modal-backdrop fade show" *ngIf="visible" (click)="onClose()"></div>

<!-- How to Buy Modal -->
<div class="modal fade show d-block" tabindex="-1" *ngIf="visible" (click)="onClose()">
  <div class="modal-dialog modal-dialog-centered modal-lg" (click)="onDialogClick($event)">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <div class="d-flex align-items-center gap-3">
          <!-- Sponsor Logo -->
          <div
            *ngIf="data?.sponsorLogoUrl"
            class="how-to-buy-logo-container"
            [style.background-color]="data?.sponsorBrandColor || 'transparent'"
          >
            <img
              [src]="getLogoFullUrl(data?.sponsorLogoUrl)"
              [alt]="(data?.sponsorName || 'Sponsor') + ' logo'"
              class="how-to-buy-logo"
            />
          </div>
          <h5 class="modal-title mb-0">
            <i class="bi bi-box-arrow-up-right me-2 text-adn"></i>Product Details
            <span *ngIf="data?.sponsorName"> - {{ data?.sponsorName }}</span>
          </h5>
        </div>
        <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">

        <!-- Loading State -->
        <div *ngIf="!dummyData && loading()" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="text-muted mt-2 mb-0">Loading contact information...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="!dummyData && !loading() && error()" class="text-center py-4">
          <i class="bi bi-exclamation-triangle fs-1 d-block mb-3 text-warning"></i>
          <h6>Unable to load contact information</h6>
          <p class="text-muted mb-0">{{ error() }}</p>
        </div>

        <!-- Content (from API or dummy data) -->
        <ng-container *ngIf="data && (dummyData || (!loading() && !error()))">

          <!-- Locations Only -->
          <ng-container *ngIf="data.contactType === 'locations_only'">
            <ng-container *ngTemplateOutlet="locationsList"></ng-container>
          </ng-container>

          <!-- Reps Only -->
          <ng-container *ngIf="data.contactType === 'reps_only'">
            <ng-container *ngTemplateOutlet="repsList"></ng-container>
          </ng-container>

          <!-- Mixed: Segmented Control -->
          <ng-container *ngIf="data.contactType === 'mixed'">
            <div class="htb-segmented-control mb-3">
              <button
                class="htb-segment"
                [class.active]="activeSubTab === 'locations'"
                (click)="setSubTab('locations')"
              >
                <i class="bi bi-geo-alt me-1"></i>Locations
                <span class="htb-segment-count">{{ data.locations.length }}</span>
              </button>
              <button
                class="htb-segment"
                [class.active]="activeSubTab === 'representatives'"
                (click)="setSubTab('representatives')"
              >
                <i class="bi bi-people me-1"></i>Representatives
                <span class="htb-segment-count">{{ data.representatives.length }}</span>
              </button>
            </div>

            <ng-container *ngIf="activeSubTab === 'locations'">
              <ng-container *ngTemplateOutlet="locationsList"></ng-container>
            </ng-container>
            <ng-container *ngIf="activeSubTab === 'representatives'">
              <ng-container *ngTemplateOutlet="repsList"></ng-container>
            </ng-container>
          </ng-container>

          <!-- Contact Form Only -->
          <ng-container *ngIf="data.contactType === 'contact_form_only'">
            <div class="text-center py-3">
              <i class="bi bi-globe fs-1 d-block mb-3 text-muted"></i>
              <p class="mb-3">{{ displayMessage }}</p>
              <a
                *ngIf="data.sponsorWebsite"
                [href]="data.sponsorWebsite"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-adn"
              >
                <i class="bi bi-box-arrow-up-right me-2"></i>Visit Website
              </a>
            </div>
          </ng-container>

        </ng-container>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Locations List Template -->
<ng-template #locationsList>
  <div *ngIf="data && data.locations.length === 0" class="text-center py-3">
    <i class="bi bi-geo-alt fs-2 d-block mb-2 text-muted opacity-50"></i>
    <p class="text-muted mb-0">No locations available.</p>
  </div>

  <ng-container *ngIf="data && data.locations.length > 0">
    <!-- Section Header -->
    <div class="htb-section-header mb-3">
      <i class="bi bi-geo-alt me-2"></i>Find a Location
      <span class="badge bg-secondary ms-2">{{ data.locations.length }}</span>
    </div>

    <div class="htb-card-list">
      <div *ngFor="let location of data.locations" class="htb-card">
        <div class="d-flex gap-3">
          <!-- Location Icon Circle -->
          <div class="htb-avatar htb-avatar-location">
            <i class="bi bi-geo-alt-fill"></i>
          </div>

          <div class="flex-grow-1 min-w-0">
            <!-- Name -->
            <div class="htb-card-name">{{ location.name }}</div>

            <!-- Address -->
            <div class="htb-card-detail mt-1">
              {{ formatAddress(location) }}
            </div>

            <!-- Contact Actions -->
            <div *ngIf="location.phone || location.email" class="d-flex flex-wrap gap-2 mt-2">
              <a *ngIf="location.phone" [href]="'tel:' + location.phone" class="htb-action-pill">
                <i class="bi bi-telephone-fill me-1"></i>{{ location.phone | phoneFormat }}
              </a>
              <a *ngIf="location.email" [href]="'mailto:' + location.email" class="htb-action-pill">
                <i class="bi bi-envelope-fill me-1"></i>{{ location.email }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Contact message below locations -->
  <div *ngIf="data && data.contactMessage" class="alert alert-info small mt-3 mb-0">
    <i class="bi bi-info-circle me-2"></i>{{ data.contactMessage }}
  </div>
</ng-template>

<!-- Representatives List Template -->
<ng-template #repsList>
  <div *ngIf="data && data.representatives.length === 0" class="text-center py-3">
    <i class="bi bi-person fs-2 d-block mb-2 text-muted opacity-50"></i>
    <p class="text-muted mb-0">No representatives available.</p>
  </div>

  <ng-container *ngIf="data && data.representatives.length > 0">
    <!-- Section Header -->
    <div class="htb-section-header mb-3">
      <i class="bi bi-people me-2"></i>Find Your Representative
      <span class="badge bg-secondary ms-2">{{ data.representatives.length }}</span>
    </div>

    <div class="htb-card-list">
      <div *ngFor="let rep of data.representatives" class="htb-card">
        <div class="d-flex gap-3">
          <!-- Initials Avatar -->
          <div class="htb-avatar htb-avatar-rep">
            {{ getInitials(rep.name) }}
          </div>

          <div class="flex-grow-1 min-w-0">
            <!-- Name + Title Badge -->
            <div class="d-flex flex-wrap align-items-center gap-2">
              <span class="htb-card-name">{{ rep.name }}</span>
              <span *ngIf="rep.title" class="htb-title-badge">{{ rep.title }}</span>
            </div>

            <!-- Territory: badges if comma-separated, plain text otherwise -->
            <div *ngIf="splitTerritory(rep.territory).length > 0" class="d-flex flex-wrap gap-1 mt-2">
              <span *ngFor="let state of splitTerritory(rep.territory)" class="htb-territory-badge">
                {{ state }}
              </span>
            </div>
            <div *ngIf="rep.territory && splitTerritory(rep.territory).length === 0" class="htb-card-detail mt-1">
              <i class="bi bi-map me-1"></i>{{ rep.territory }}
            </div>

            <!-- Contact Actions -->
            <div *ngIf="hasContactInfo(rep)" class="d-flex flex-wrap gap-2 mt-2">
              <a *ngIf="rep.phone" [href]="'tel:' + rep.phone" class="htb-action-pill">
                <i class="bi bi-telephone-fill me-1"></i>{{ rep.phone | phoneFormat }}
              </a>
              <a *ngIf="rep.email" [href]="'mailto:' + rep.email" class="htb-action-pill">
                <i class="bi bi-envelope-fill me-1"></i>{{ rep.email }}
              </a>
            </div>

            <!-- No Contact Fallback -->
            <div *ngIf="!hasContactInfo(rep)" class="htb-no-contact mt-2">
              <i class="bi bi-info-circle me-1"></i>Contact sponsor directly for this region
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Contact message below representatives -->
  <div *ngIf="data && data.contactMessage" class="alert alert-info small mt-3 mb-0">
    <i class="bi bi-info-circle me-2"></i>{{ data.contactMessage }}
  </div>
</ng-template>
